import { useQuery } from '@tanstack/react-query';
import getReport from '../../utils/api/mediaValueReport';

const key = 'insights';

type Report = {
    changesId: string;
    lastQuery: any;
    total: any;
    values: any[];
};

const fetchReport = async (
    key: string,
    filters: any,
    query: any,
    client: any,
): Promise<Report | null> => {
    if (!filters || !query) {
        return {
            changesId: '',
            lastQuery: null,
            total: null,
            values: [],
        };
    }
    try {
        const report = await getReport(filters, query, client);
        const changesId = filters.changesId;
        const { values, total } = report;

        return {
            changesId,
            lastQuery: query,
            total,
            values,
        };
    } catch (error) {
        return {
            changesId: '',
            lastQuery: null,
            total: null,
            values: [],
        };
    }
};

const useInsights = ({
    filters,
    query,
    client,
    enabled = true,
}: {
    filters: any;
    query: any;
    client: any;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: [key, filters, query],
        queryFn: () => fetchReport(key, filters, query, client),
        staleTime: 240000,
        enabled,
    });

export default useInsights;
